import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { uiConstants } from "./ui.constants";

export type AlertVariant = "success" | "warning" | "info" | "failure";

export type Alert = {
	show: boolean;
	variant: AlertVariant;
	title: string;
};

export type UIState = {
	alerts: Alert[];
	isSpinnerOverlayVisible: boolean;
	isOverlayTransparent: boolean;
	spinnerOverlayAdditionalTitle?: string;
	modals: any[];
	isOnline: boolean;
};

const initialState: UIState = {
	alerts: [],
	isSpinnerOverlayVisible: false,
	spinnerOverlayAdditionalTitle: "",
	isOverlayTransparent: true,
	modals: [],
	isOnline: true,
};

export const getUIState = state => state.ui;

const selector = property => fp.flow(getUIState, fp.get(property));

export const getModals = selector("modals");

export const getAlerts = selector("alerts");

export const getIsOnline = selector("isOnline");

const popModal = (modals, modalType) => {
	const lastModalByTypeIndex = fp.findLastIndex({ modalType }, modals);
	const newModals = fp.clone(modals);
	newModals.splice(lastModalByTypeIndex, 1);
	return newModals;
};

const popAlert = (alerts, title) => {
	const newAlerts = fp.clone(alerts);
	return newAlerts.filter(a => a.title !== title);
};

function ui(state: UIState = initialState, action) {
	switch (action.type) {
		case uiConstants.SHOW_ALERT:
			return {
				...state,
				alerts: [
					...state.alerts,
					{
						show: true,
						title: action.title,
						variant: action.variant,
					},
				],
			};
		case uiConstants.HIDE_ALERT:
			return {
				...state,
				alerts: popAlert(state.alerts, action.title),
			};
		case uiConstants.SHOW_SPINNER_OVERLAY:
			return {
				...state,
				isSpinnerOverlayVisible: true,
				isOverlayTransparent: action.isOverlayTransparent,
				spinnerOverlayAdditionalTitle:
					action.spinnerOverlayAdditionalTitle,
			};
		case uiConstants.HIDE_SPINNER_OVERLAY:
			return {
				...state,
				isSpinnerOverlayVisible: false,
				spinnerOverlayAdditionalTitle: "",
				isOverlayTransparent: true,
			};
		case uiConstants.PUSH_MODAL:
			return {
				...state,
				modals: [...state.modals, action.modal],
			};
		case uiConstants.POP_MODAL:
			return {
				...state,
				modals: popModal(state.modals, action.modalType),
			};
		case uiConstants.SET_IS_ONLINE:
			return fp.set("isOnline", action.isOnline, state);
		default:
			return state;
	}
}

export default withResetState({ initialState })(ui);
